import { require200Status } from "../../utils/response.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
import { RewardsStatusSpecs } from "../../../types/models/wallet.specs.js";
import { FundingModelConvertSpec } from "../../../types/models/transaction.specs.js";
function rewardsEndpoints(builder) {
  return {
    getRewardsStatus: builder.query({
      //controlled fetch
      query: () => ({
        url: `/member/wallet/reward/status`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(RewardsStatusSpecs)
    }),
    claimReward: builder.mutation({
      invalidatesTags: ["rewards"],
      query: ({ seonSession, query, compensationTxId }) => ({
        url: `/member/wallet/reward/claim${parseQs(query)}`,
        validateStatus: require200Status,
        method: "POST",
        body: {
          seonSession,
          compensationTxId
        }
      }),
      transformResponse: transformWithSpec(FundingModelConvertSpec)
    })
  };
}
export {
  rewardsEndpoints as default
};
